import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { RoleProviderService } from '../providers/role-provider.service';
import { isNil, Nillable } from '@web/utils';
import { Role } from '../enums/role';

@Pipe({
  name: 'roleLabel',
  standalone: true,
})
export class RoleLabelPipe implements PipeTransform {
  private readonly provider = inject(RoleProviderService);

  public transform(role: Nillable<Role>): Observable<Nillable<string>> {
    if (isNil(role)) {
      return of(role);
    }

    return this.provider.label(role);
  }
}
